var map = {
	"./favicon.ico": 27274,
	"./logo-full.png": 14153,
	"./logo-itinerary.png": 6275,
	"./logo-white.png": 95695
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 42635;
module.exports = webpackAsyncContext;